export default {

    // OFFLINE LEADS SERVICE

    ADD_OFFLINE_LEADS: {
        url: "/api/v1/offlineLeads",
        method: "post",
    },
    FETCH_OFFLINE_LEADS: {
        url: "/api/v1/offlineLeads",
        method: "get",
    },
    GET_OFFLINE_BY_ID: {
        url: "/api/v1/offlineLeads/{leadId}",
        method: "get",
    },
    UPDATE_OFFLINE_BY_ID: {
        url: "/api/v1/offlineLeads/{leadId}",
        method: "put",
    },
    DELETE_OFFLINE_BY_ID: {
        url: "/api/v1/offlineLeads/{leadId}",
        method: "delete",
    },
    // BULK FILES
    BULK_UPLOAD_OFFLINE_LEADS: {
        url: "/api/v1/offlineLeads/upload",
        method: "post",
    },
    DOWNLOAD_OFFLINE_LEADS_TEMPLATE: {
        url: "/api/v1/offlineLeads/template",
        method: "get",
    },
}